import {
  FacebookIconTwoTone,
  InstagramIconTwoTone,
  YoutubeIconTwoTone,
  TikTokIconTwoTone,
  LinkedInIconTwoTone,
  SoundCloudIconTwoTone,
  WebIcon,
  ImdbIcon,
} from '@room-match/shared-ui-components';
import TwitterXIcon from 'shared/components/Icon/TwitterXIcon';

export interface ISocialMediaConstItem {
  label: string;
  platform: string;
  icon: any;
  prefix: string;
  placeholder: string;
}

export const socialMediaList: ISocialMediaConstItem[] = [
  {
    label: 'Facebook',
    platform: 'facebook',
    icon: <FacebookIconTwoTone />,
    prefix: 'fb.com/',
    placeholder: 'username',
  },
  {
    label: 'X',
    platform: 'twitter',
    icon: <TwitterXIcon />,
    prefix: '@',
    placeholder: 'username',
  },
  {
    label: 'Instagram',
    platform: 'instagram',
    icon: <InstagramIconTwoTone />,
    prefix: '@',
    placeholder: 'username',
  },
  {
    label: 'YouTube',
    platform: 'youtube',
    icon: <YoutubeIconTwoTone />,
    prefix: 'youtube.com/',
    placeholder: 'username',
  },
  { label: 'TikTok', platform: 'tiktok', icon: <TikTokIconTwoTone />, prefix: '@', placeholder: 'username' },
  {
    label: 'LinkedIn',
    platform: 'linkedin',
    icon: <LinkedInIconTwoTone />,
    prefix: 'linkedin.com/in/',
    placeholder: 'username',
  },
  {
    label: 'SoundCloud',
    platform: 'soundcloud',
    icon: <SoundCloudIconTwoTone />,
    prefix: 'soundcloud.com/',
    placeholder: 'username',
  },
  // {
  //   label: 'Personal Website',
  //   platform: 'personal_website',
  //   icon: <WebIcon />,
  //   prefix: '',
  //   placeholder: 'www.casting.com',
  // },
  // { label: 'IMDb', platform: 'imdb', icon: <ImdbIcon />, prefix: 'imdb.com/name/', placeholder: 'username' },
];
